import angular from 'angular';

(function () {
    'use strict';

    // Composant affichant le détail du monitoring d'un module

    angular.module('app.admin.monitoring').component('monitoringDetails', {
        bindings: {
            details: '<', // Détails du statut à afficher
            baseUrl: '<', // URL
        },
        templateUrl: require('./monitoring-details.html'),
        controller: 'MonitoringDetailsController as vm',
    });

    angular.module('app.admin.monitoring').controller('MonitoringDetailsController', MonitoringDetailsController);

    function MonitoringDetailsController() {
        var vm = this;

        vm.otherDetails = {};
        vm.hasOtherDetails = false;

        vm.$onInit = function () {
            // Remplit otherDetails avec les propriétés qui ne sont pas reconnues nativement
            var knowProps = [
                'message',
                'rationale',
                'batchId',
                'envelopeId',
                'folderId',
                'rationale',
                'messageId',
                'exportLink',
            ];
            if (vm.details) {
                var keys = Object.keys(vm.details);
                keys.forEach(function (item /*, index, array*/) {
                    if (knowProps.indexOf(item) === -1) {
                        vm.otherDetails[item] = vm.details[item];
                        vm.hasOtherDetails = true;
                    }
                });
            }
        };
    }
})();
